// FounderStory.js
import React from "react";
import "./FounderStory.css";
import founderImage from "../../assets/images/founder1.jpg";
import { Link } from "react-router-dom";

export default function FounderStory() {
  return (
    <section className="founderSection" aria-labelledby="founder-title">
      <div className="founderContainer">
        <div className="founderGrid">
          {/* Image (LEFT on desktop, BELOW on mobile via CSS order) */}
          <div className="founderImageCol">
            <div className="founderImageCard">
              <img
                src={founderImage}

                alt="Criador do app trabalhando no notebook"
                className="founderImage"
                loading="lazy"
              />

              <div className="founderBadge" aria-label="Mensagem do criador">
                <span className="founderBadgeIcon" aria-hidden="true">
                  ❤️
                </span>
                <span className="founderBadgeText">Feito com amor para quem aprende</span>
              </div>
            </div>
            <p className="founderQuote founderQuote--underImage">
                Esse app foi feito para aprender melhor.  
                Espero que você aproveite.
            </p>
          </div>

          {/* Text (RIGHT on desktop, TOP on mobile) */}
          <div className="founderTextCol">
            <h2 id="founder-title" className="founderTitle">
              Criado por quem aprende idiomas —{" "}
              <span className="founderTitleAccent">para quem aprende idiomas</span>
            </h2>

            <p className="founderP">
              <strong>Aprender novas línguas mudou a minha vida.</strong>{" "}
              Novas culturas, conexões reais com pessoas incríveis, oportunidades que só aparecem quando você consegue se comunicar de verdade — e sei que pode fazer o mesmo por você.
            </p>

            <p className="founderP">
              {/* Muitos aplicativos exigem que você fale inglês para aprender outro idioma — o que exclui muita gente. 
              Outros transformam o aprendizado em um jogo, mas deixam de lado aquilo que realmente importa. */}
              Sempre quis aprender com contexto real, e não com exercícios aleatórios que não têm muito a ver com a vida real. Mas toda hora batia no mesmo
              problema: não entendia as palavras, perdia o contexto —{" "}
              <strong>e a motivação ia embora.</strong>
            </p>


            <p className="founderP">
              Por isso criei esse applicativo que eu mesmo gostaria de usar: um lugar onde você aprende idiomas{" "}
              <strong>lendo e escutando sobre temas reais</strong>, com
              todo o apoio necessário para não travar no meio do caminho.
            </p>

            <div className="founderCallout" role="note" aria-label="Resumo do método">
              <p className="founderCalloutText">
                Assim, você sai dos exercícios aleatórios e entra no idioma de verdade.{" "}
                {/* <strong>Você faz as duas coisas ao mesmo tempo.</strong> */}
              </p>
            </div>
          </div>
        </div>
      </div>

      <div className="hiw__cta">
        <button
          className="topfold-cta"
          data-tally-open="mYN7Dz"
          data-tally-layout="modal"
          data-tally-hide-title="1"
          onClick={() => {
            if (!window.Tally) window.open("https://tally.so/r/mYN7Dz", "_blank", "noopener,noreferrer");
          }}
        >
          Entre na lista
        </button>
        </div>

      {/* <div className="hiw__cta">
            <Link to="/signup" className="btn start-btn">
            Comece grátis
            </Link>
          </div> */}
    </section>

    
  );
}
